import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-locize-backend';
import Config from './config.js';
import { locizePlugin } from 'locize';
import { DateTime } from "luxon";

import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
 // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(Backend)
  .use(locizePlugin)
  .init({
    backend: {
      projectId: '7b76c770-7f92-4422-ab16-d263b3e2cfb6',
      referenceLng: 'fr'
    },
    ns: ['common', 'lang', 'auth', Config.Locize.ProjectNamespace],
    supportedLngs: ['fr'],
    fallbackLng: ['fr'],
    saveMissing: true,
    debug: false,
    useSuspense: true,
    keySeparator: false,    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function(value, format, lng) {
       if (format === 'performance_date_format') {
         let organiserLocalDate = DateTime.fromISO(value.date, {zone: value.timezone});
         let userLocalDate = organiserLocalDate.toLocal();
         let suffix = "";
         let format = DateTime.DATETIME_MED;
         if (organiserLocalDate.offset !== userLocalDate.offset) {
           suffix = "("+value.timezone+")";
           format = DateTime.DATETIME_FULL;
         }
         return organiserLocalDate.setLocale(lng).toLocaleString(format)+suffix;
       }
       if (format === 'booking_date_format') {
         return DateTime.fromISO(value).setLocale(lng).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
       }
       return value;
      }
    },
    react: {
      bindI18n: 'languageChanged editorSaved'  //Only for translator inContext interface
    }
  });


export default i18n;
